import React, { useRef, useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import DashboardHeader from "../dashboard/DashboardHeader/DashboardHeader";
import ChatUsers from "./auxiliary/ChatUsers";
import { Offcanvas } from 'react-bootstrap'
import ChatRoom from "./auxiliary/ChatRoom";
import CustomSvg from "../svgs/CustomSvg";
import './css/chat.css';


export default function Chat({accountType}){

    const [activeChat, setActiveChat] = useState(null);
    const [showUsersOffcanvas, setShowUsersOffcanvas] = useState(true);
    const location = useLocation();
    
    useEffect(() => {
        // Check if we have a selected user from navigation
        if (location.state?.selectedUser) {
            setActiveChat(location.state.selectedUser);
            // Close the users panel if we have a selected user
            setShowUsersOffcanvas(false);
        }
    }, [location.state]);
    
    // Initial display of users list when component mounts
    useEffect(() => {
        // On larger screens, we don't need to show the offcanvas
        const isLargeScreen = window.innerWidth >= 768; // md breakpoint
        if (isLargeScreen) {
            setShowUsersOffcanvas(false);
        }
    }, []);

    const selectActiveChat = user => setActiveChat(user)

    const openUsersOffcanvas = () => setShowUsersOffcanvas(true)
    const closeUsersOffcanvas = () => setShowUsersOffcanvas(false)

    const toggleUsersOffcanvas = () => setShowUsersOffcanvas(prev => !prev)

    return (
        <div className="min-h-screen bg-[#130828] dashboard">
  <DashboardHeader />

  <div className="p-4 flex justify-between" style={{ height: 'calc(100vh - 80px)' }}>
    {/* Chat Room */}
    <div className="w-full md:w-2/3 lg:w-3/4 px-0 md:px-4">
      <ChatRoom activeChat={activeChat} accountType={accountType}/>
    </div>
    {/* Hamburger menu for mobile - right side */}
    <div className="block md:hidden absolute top-4 right-4 z-20">
      <button onClick={toggleUsersOffcanvas} className="p-2">
        <span className="block w-6 h-0.5 bg-white mb-1 rounded"></span>
        <span className="block w-6 h-0.5 bg-white mb-1 rounded"></span>
        <span className="block w-6 h-0.5 bg-white rounded"></span>
      </button>
    </div>
    {/* Sidebar users list - hidden on small screens */}
    <div className="hidden md:block md:w-1/3 lg:w-1/4">
      <ChatUsers 
        selectActiveChat={selectActiveChat}
        activeChat={activeChat}
      />
    </div>
  </div>

  {/* Offcanvas for mobile user list */}
  <Offcanvas show={showUsersOffcanvas}>
    <div className="w-full h-screen overflow-y-auto bg-[#130828]">
      <div className="w-full h-full">
        <div className="flex items-center justify-between p-4 mb-5">
          <h1 className="text-white text-xl font-bold font-['Quantico']">
            User <span className="text-[#BD3193]">Chats</span>
          </h1>
          <div onClick={closeUsersOffcanvas} className="cursor-pointer">
            <CustomSvg name="x" color="#FFF" />
          </div>
        </div>

        <ChatUsers 
          selectActiveChat={selectActiveChat}
          activeChat={activeChat}
          closeUsersOffcanvas={closeUsersOffcanvas}
        />
      </div>
    </div>
  </Offcanvas>
</div>

    )
}